import { Box } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { useReactToPrint } from "react-to-print";
import { useCallback, useEffect, useRef, useState } from "react";
import QrPrintContent from '../../../../LogisticsManagement/InBound/QrPrintContent'
import { useSelector } from "react-redux";
import { selectFollowCycle } from '../../../../../slices/common';
import RePrintForm from "../../../../../components/features/LmsKitLabel/RePrintForm";
import BsModal from "../../../../../components/common/BaseModal";

const DownloadLabelPrint = ({fetchTimeLineApi,qrCodeDataUrl,patientData, patientMedicalInfo,patientInfo}) =>{
  const [printData, setPrintData] = useState(null);
  const printTimeoutAllRef = useRef(null);
  const printContentAllRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handlePrintClick = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const currentCycle =  useSelector(selectFollowCycle)

      const reactToPrintFnAll = useReactToPrint({
        content: () => printContentAllRef.current,
      });

  useEffect(() => {   
      const result = {
        printPatientInfo:patientData,
        qrCodeDataUrl,
        bagCount:patientInfo?.bagCount,
        printCount: 1,
        printSingleBag: ' ',
        patientMedicalInfo
      };
      setPrintData(result);
    }, [patientData,patientMedicalInfo,qrCodeDataUrl])
 
const [shouldPrint, setShouldPrint] = useState(false);
const isPrintContentReady = useRef(false);

// In your DownloadLabelPrint component, add a useEffect to signal when ready
// DownloadLabelPrint component:
useEffect(() => {
  // Content is rendered and ready
  if (printData) {
    isPrintContentReady.current = true;
  }
}, [printData]);

// In your parent component:
const handleFullPrint = useCallback((value) => {
  
  let count = 1;
  let singleBag = null;

  if (value?.bag_no) {
    count = 1;
    singleBag = value?.bag_no;
  } else {
    count = value?.bags || currentCycle?.no_of_bags;
    singleBag = null;
  }
  
  // Reset ready flag
  isPrintContentReady.current = false;
  
  // Prepare and set print data
  const printData = {
    printPatientInfo: patientData,
    qrCodeDataUrl,
    bagCount: value?.bag_no,
    printCount: count,
    printSingleBag: singleBag,
    patientMedicalInfo
  };
  
  setPrintData(printData);
  if(fetchTimeLineApi)
  fetchTimeLineApi();
  setShouldPrint(true);
  
}, [reactToPrintFnAll, fetchTimeLineApi]);

useEffect(() => {
  if (shouldPrint) {
    const checkContentAndPrint = () => {
      if (isPrintContentReady.current) {
        reactToPrintFnAll();
        setShouldPrint(false);
      } else {
        // Check again after delay
        printTimeoutAllRef.current = setTimeout(checkContentAndPrint, 50);
      }
    };
    
    checkContentAndPrint();
  }
  
  return () => {
    if (printTimeoutAllRef.current) {
      clearTimeout(printTimeoutAllRef.current);
    }
  };
}, [shouldPrint, reactToPrintFnAll]);

    return (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <LoadingButton
                    type="button"
                    size="small"
                    onClick={handlePrintClick}
                    className="!w-[100px] "
                  >
                    Re-Print
                  </LoadingButton>
                </Box>
                {printData && (<div className="mx-auto flex justify-center">
                     <QrPrintContent
                    ref={printContentAllRef}
                    printData={printData}
                    isVisible={true}
                  />
                  </div>)} 
  <BsModal
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleCloseModal}
        title="Print QR Code"
        className="p-4"
      >
                   <RePrintForm
                              qrCodeId={currentCycle?.qr_code_generation_id}
                              bagCount={currentCycle?.no_of_bags}
                              handleCloseModal={handleCloseModal}
                              handlePrint={handleFullPrint}
                            /></BsModal>

                </>
      );
}
export default DownloadLabelPrint